import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
// ... existing code ...
import { HelmetProvider } from "react-helmet-async";
import Search from "./pages/Search";
import Profile from "./pages/Profile";
import Boost from "./pages/Boost";
import Privacy from "./pages/Privacy";
import Consent from "./pages/Consent";
// ... existing code ...

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <HelmetProvider>
        <TooltipProvider>
          <Toaster />
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/search" element={<Search />} />
              <Route path="/p/:handle" element={<Profile />} />
              <Route path="/boost" element={<Boost />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/consent" element={<Consent />} />
              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </TooltipProvider>
      </HelmetProvider>
    </QueryClientProvider>
  );
}

export default App;